import React from 'react'
import { Box, Image } from '@chakra-ui/core'
import { AudioPlayer } from 'components/AudioPlayer'

interface IPopMediaProps {
  pop_image_url?: string
  audio?: string
  video?: string
  preserveImageAspectRatio?: boolean
}

export function PopMedia({ pop_image_url, audio, video, preserveImageAspectRatio = false }: IPopMediaProps) {
  return (
    <>
      {pop_image_url && (
        <Image
          src={pop_image_url}
          w={preserveImageAspectRatio ? 'auto' : '140pt'}
          height={preserveImageAspectRatio ? 'auto' : '140pt'}
          maxH="160pt"
          maxW="100%"
          objectFit={preserveImageAspectRatio ? 'contain' : undefined}
          mx="auto"
          mt="15pt"
        />
      )}
      {audio && (
        <Box mt="15pt" width="100%">
          <AudioPlayer src={audio} />
        </Box>
      )}
      {video && (
        <Box mt="15pt" width="100%">
          <video src={video} controls style={{ width: '100%', maxWidth: '500px', borderRadius: '10px' }} />
        </Box>
      )}
    </>
  )
}
